import React,{useEffect,useState} from 'react';
import { formValidateField } from '../../../helpers/formvalidation'; 
import LocalMessage from '../../../components/LocalMessage';

const LoginForm = (props) => {
    const {
        onSubmit,
        onRecoveryPasswordClick
    } = props
    
    const formInitialState = {
        "email":{
            "value":"",
            "name":"email",
            "error":""
        },
        "password":{    
            "value":"",
            "name":"password",
            "error":""
        }
    }

    const [form, setForm] = useState(formInitialState);
    const [loading, setLoading] = useState(false);
    const [message,setMessage] = useState({
        value:"",
        type:""
    });
    

    const handleFormChange = (e)=>{
        const {
            name,
            value
        } = e.target       
        setForm({
            ...form,
            [name]:{
                ...form[name],
                value
            }
        })
    }

    const handleRecoveryPasswordClick = (e) =>{        
        if(onRecoveryPasswordClick){
            onRecoveryPasswordClick()
        }
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        setMessage({
            value:"",
            type:""
        })
        const {
            email,
            password
        } = form
        let formToValidate = {
            "email":{
                ...email,                
                "error":""
            },
            "password":{    
                ...password,                
                "error":""
            }
        }
       
        let valid = true
        setLoading(true)

        if(!formValidateField(email.value,'email')){
            formToValidate = {
                ...formToValidate,
                'email':{
                    ...email,
                    "error":"The email is not valid"
                }
            }
            valid = false
        }        
        if(!formValidateField(email.value,'required')){
            formToValidate = {
                ...formToValidate,
                'email':{
                    ...email,
                    "error":"The email is required"
                }
            }
            valid = false
        }
        console.log('email value',email.value)
        
        if(!formValidateField(password.value,'required')){
            formToValidate = {
                ...formToValidate,
                'password':{
                    ...password,
                    "error":"The password is required"
                }
            }
            valid = false
        }
        
        if(valid){
            if(onSubmit){
                onSubmit(
                    {
                        "email":email.value,
                        "password":password.value
                    },
                    (success)=>{
                        setLoading(false)
                    },
                    (error)=>{
                        console.log(error)
                        setLoading(false)
                        setMessage({
                            "value":error,
                            "type":"error"
                        })                        
                    }
                )
            }
        }else{
            setLoading(false)
            setForm(formToValidate)
        }
    }

    return (        
        <form onSubmit={handleSubmit}>
            <div className="form-group row">
                <div className="col-12 text-center">                   
                    <h4>
                        Login
                    </h4>
                </div>
            </div>
            <div className="form-group my-1">
                <label htmlFor="email">Email</label>
                <input 
                    name='email' 
                    placeholder='email' 
                    className='form-control form-control-sm' 
                    type="email" 
                    onChange={handleFormChange} 
                />
                {form.email.error!==""&&<p className='text-danger'>{form.email.error}</p>}
            </div>
            <div className="form-group my-1">
                <label htmlFor="password">Password</label>
                <input 
                    name='password' 
                    placeholder='password' 
                    className='form-control form-control-sm' 
                    type="password" 
                    onChange={handleFormChange}
                />
                {form.password.error!==""&&<p className='text-danger'>{form.password.error}</p>}
            </div>
            <div className="row justify-content-end">
                <div className="col-auto">
                    <button
                        className='btn-sm btn btn-link'
                        type='button'
                        onClick={handleRecoveryPasswordClick}
                    >
                        Recover password
                    </button>                    
                </div>
            </div>

            <div className="row my-1">
                <div className="col-12">
                    <p>
                        <LocalMessage 
                            message={message.value}
                            type={message.type}
                        />
                    </p>
                </div>
            </div>



            <div className="form-group row justify-content-center">
                <div className="col-auto">
                    <button 
                        disabled={loading}
                        className="btn-sm btn btn-secondary" 
                        type='submit'                        
                        >
                        {!loading?"Start": <span><i className="fa fa-spinner fa-spin"> </i> loading...</span>}
                    </button>
                </div>
            </div>
        </form>        
    );
}

export default LoginForm;
